module.exports = __webpack_public_path__ + "static/olofinlade-2f78ef54009106b447f689ebe72a3632.jpeg";